import debugFactory from 'debug';

import { IpcInstance } from './ipc';

const debug = debugFactory('ingrid:bootstrap');

export interface ReadyIpcEvent {
  name: 'ready_for_messages';
}

export function listenToReady(ipc: IpcInstance<any>, callback: () => void) {
  ipc.listen(payload => {
    if (payload.name === 'ready_for_messages') {
      callback();
      debug('Ready for messages');
    }
  });
}

export function sendReady(ipc: IpcInstance<ReadyIpcEvent>) {
  ipc.send({ name: 'ready_for_messages' });
}
